// src/MyPagination.js
import * as React from 'react'
import { Pagination } from 'react-admin'

export const MyPagination = props => (
  <Pagination
    rowsPerPageOptions={[10, 25, 50]}
    labelDisplayedRows={({ from, to, count }) =>
      ` ${from} – ${to} de ${count} `
    }
    {...props}
  />
)
